import React, { useEffect, useState } from "react";
import FullCircleChart from "../ResourceProfile/FullCircleChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { Modal, Button } from "react-bootstrap";
import InputLebelComponent from "../../InputLebel/InputLebelComponent";
import saveResourceAvailability from "../../../apis/saveResourceAvailability";
import { useAuthContext } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AvailabilityV2 = ({ availabilityDetails, resourceSlug }) => {
  const { userDetails } = useAuthContext();
  const current_user_slug =
    typeof userDetails === "string"
      ? JSON.parse(userDetails).user_slug
      : userDetails.user_slug;

  const [availability, setAvailability] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);

  useEffect(() => {
    if (availabilityDetails?.availability !== undefined) {
      setAvailability(parseInt(availabilityDetails.availability));
      setIsLoading(false);
    }
  }, [availabilityDetails]);

  const handleEditClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSubmitError(null);
    setSubmitSuccess(null);
    if (availabilityDetails?.availability !== undefined) {
      setAvailability(parseInt(availabilityDetails.availability));
    }
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(null);

    try {
      const formData = {
        current_user_slug,
        resourceSlug,
        availability,
      };

      const res = await saveResourceAvailability(formData);
      if (res?.data?.status === 1) {
        toast.success(res.data.message); // ✅ show toast
        setShowModal(false); // ✅ close immediately
      } else {
        toast.warning(res.data.message || "Something went wrong."); // ✅ show warning
      }
    } catch (error) {
      toast.error("Network error. Please try again."); // ✅ show error
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h6 className="mb-0">Available Hours / Week</h6>
        <FontAwesomeIcon
          icon={faEdit}
          className="text-primary cursor-pointer"
          role="button"
          title="Edit Availability"
          onClick={handleEditClick}
        />
      </div>

      {!isLoading && (
        <div className="d-flex justify-content-center mt-3">
          <FullCircleChart value={availability} size={70} />
        </div>
      )}

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        backdrop="static"
      >
        <Modal.Header>
          <span className="fw-bold-custom">Edit Your Weekly Availability</span>
        </Modal.Header>

        <Modal.Body>
          <InputLebelComponent title="I'm available up to" />
          <div className="mt-3">
            <div className="row g-2">
              {[40, 30, 20, 10, 5, 0].map((val) => (
                <div className="col-6" key={val}>
                  <div
                    className={`p-3 rounded border w-100 text-center fw-medium cursor-pointer ${
                      availability === val
                        ? "border-primary bg-light text-primary"
                        : "border-secondary"
                    }`}
                    style={{ userSelect: "none" }}
                    onClick={() => setAvailability(val)}
                  >
                    {val > 0 ? `${val} hrs/week` : "Not Currently Available"}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="dark"
            onClick={handleCloseModal}
            disabled={isSubmitting}
          >
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AvailabilityV2;
